import schema, { generateType } from './Schema';
export const Product = generateType(schema.getModel('product'));
//# sourceMappingURL=ProductModel.js.map